import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function withAuth<P extends object>(
  WrappedComponent: React.ComponentType<P>,
  requiredRole?: string,
) {
  return function WithAuthComponent(props: P) {
    const { user, loading } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (!loading && !user) {
        navigate('/');
      } else if (
        !loading &&
        user &&
        requiredRole &&
        user?.role !== requiredRole
      ) {
        navigate('/404');
      }
    }, [user, loading, navigate]);

    // Show nothing while checking authentication
    if (loading) {
      return null;
    }

    // Only render the component if user is authenticated and has role
    const hasAccess = user && (!requiredRole || user?.role === requiredRole);
    return hasAccess ? <WrappedComponent {...props} /> : null;
  };
}
